import { CustomProperty, CustomPropertyType } from '@evidentid/tprm-portal-lib/models/dashboard';

export function isEnumCustomProperty(customProperty: CustomProperty): boolean {
    return customProperty.type === CustomPropertyType.enum;
}
